module.exports = __webpack_public_path__ + "fonts/Staatliches-Regular.woff";